export const COM_LABELS = {
  AVG: 'Avg. COM%',
  CURRENT: 'Current COM%',
};
